const MAIN_DOMAIN = 'proServices/Wishlists';

export const WISHLIST_ACTIONS = {
  DISPLAY_NOTIFICATION: `${MAIN_DOMAIN}/DISPLAY_OK_NOTIFICATION`,
  HIDE_NOTIFICATION: `${MAIN_DOMAIN}/HIDE_NOTIFICATION`,
  OPEN_MODAL: `${MAIN_DOMAIN}/OPEN_MODAL`,
  CLOSE_MODAL: `${MAIN_DOMAIN}/CLOSE_MODAL`,
} as const;

export interface WishlistNotificationData {
  text: string;
  level: 'warning' | 'success' | 'info' | 'danger';
  returnable?: { id: 'cart' | number; quantity: number; productId: number };
}
export type DisplayNotificationAction = {
  type: typeof WISHLIST_ACTIONS.DISPLAY_NOTIFICATION;
} & WishlistNotificationData;

export interface HideNotificationAction {
  type: typeof WISHLIST_ACTIONS.HIDE_NOTIFICATION;
}

export interface OpenModalAction {
  type: typeof WISHLIST_ACTIONS.OPEN_MODAL;
  modalId: string;
}

export interface CloseModalAction {
  type: typeof WISHLIST_ACTIONS.CLOSE_MODAL;
}

export const displayNotificationAction = (
  text: string,
  level: 'warning' | 'success' | 'info' | 'danger' = 'info',
  returnable?: { id: 'cart' | number; quantity: number; productId: number },
): DisplayNotificationAction => ({
  type: WISHLIST_ACTIONS.DISPLAY_NOTIFICATION,
  text,
  level,
  returnable,
});

export const hideNotificationAction = (): HideNotificationAction => ({
  type: WISHLIST_ACTIONS.HIDE_NOTIFICATION,
});

export const openModalAction = (modalId: string): OpenModalAction => ({
  type: WISHLIST_ACTIONS.OPEN_MODAL,
  modalId,
});

export const closeModalAction = (): CloseModalAction => ({
  type: WISHLIST_ACTIONS.CLOSE_MODAL,
});

export type WishlistAction =
  | DisplayNotificationAction
  | HideNotificationAction
  | OpenModalAction
  | CloseModalAction;
